import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Link } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import axios from 'axios';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';
import ReactGA from "react-ga4";

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

class ViewOrders extends React.Component {

    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null);
        let historyExists = !(props.history.location.state == null || props.history.location.state.data == null)
        this.state = {
            user: userExists ? props.location.state.user : {},
            page: historyExists ? props.history.location.state.page : 1,
            data: historyExists ? props.history.location.state.data :  [],
            totalSize: historyExists ? props.history.location.state.totalSize :  0,
            sizePerPage: historyExists ? props.history.location.state.sizePerPage :  20,
            accounts: historyExists ? props.history.location.state.accounts :  [],
            selectedAccounts: historyExists ? props.history.location.state.selectedAccounts : [],
            accountSearchString: historyExists ? props.history.location.state.accountSearchString : '',
            filterStatus: historyExists ? props.history.location.state.filterStatus : '',
            filterType: historyExists ? props.history.location.state.filterType : '',
            searchTerm: historyExists ? props.history.location.state.searchTerm : '',
            loading: false
        };

        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.getAccounts = this.getAccounts.bind(this);
        this.selectAccounts = this.selectAccounts.bind(this);


        this.loadingSpinner = this.loadingSpinner.bind(this);

        this.filterStatus = React.createRef();
        this.filterType = React.createRef();
        this.filterText = React.createRef();
    }

    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No records.';
        }
    };

    handleClear(event) {
        event.preventDefault();
        this.filterStatus.current.value = "";
        this.filterType.current.value = "";
        this.filterText.current.value = "";

        this.setState({
            filterStatus: '',
            searchTerm: '',
            filterType: '',
            selectedAccounts: [],
            page:1
        }, function () {
            this.handleTableChange("search", this.state)
        });
    }

    handleSearch(event) {
        event.preventDefault();
        this.setState({
            page: 1
        }, this.handleTableChange("search", this.state));
    }

    handleFilterChange(event) {
        let input = this.state;
        input[event.target.name] = event.target.value;
        this.setState({
            input,
            page: 1
        }, function () {
            this.handleTableChange("search", this.state)
        });
    }

    handleSearchChange(event) {
        this.setState({
            searchTerm: event.target.value
        });
    }
    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {

        ReactGA.event({
            category: 'Search',
            action: 'Order History',
            label: 'Order History Search'
        });

        this.setState({
            loading: true,
            data:[],
            page,
            sortOrder,
            sortField,
            sizePerPage
        },
        function () {

            axios.get(`${Constants.apiURL}/api/Order/GetOrders`, {
                params: {
                    user: this.state.user.username,
                    page: this.state.page,
                    pageSize: this.state.sizePerPage,
                    sortOrder: this.state.sortOrder,
                    sortField: this.state.sortField,
                    searchTerm: this.state.searchTerm.trim(),
                    filterType: this.state.filterType,
                    filterStatus: this.state.filterStatus,
                    accountSearchString: this.state.accountSearchString
                }
            }).then(response => {
                if (response.data) {

                    this.setState(() => ({
                        data: JSON.parse(response.data.data),
                        totalSize: response.data.rowcount,
                        page,
                        sortOrder,
                        sortField,
                        sizePerPage,
                        loading: false
                    }), this.getAccounts);
                }
            }).catch((response) => {
                if (response.response.status === 401) {
                    this.props.history.push({
                        pathname: '/'
                    });
                }
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
            });
        });
    }

    getAccounts() {
        this.props.history.replace({
            ...this.props.history.location,
            state: this.state
        });

        axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
            params: {
                username: this.state.user.username,
                isWork: true
            }
        }).then(response => {
            if (response.data) {
                let accounts = response.data.map(function (acc) {
                    return {
                        label: acc.accountID + " | " + acc.accountName,
                        value: acc.accountID
                    };
                });

                this.setState(() => ({
                    accounts: accounts
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    selectAccounts(selected) {
        let selectedAccountsString = selected.map((item) => {
            return item.value
        }).join(',');
        this.setState({
            selectedAccounts: selected,
            accountSearchString: selectedAccountsString
        }, () => this.handleTableChange("search", this.state));
    }

    render() {


        const defaultSorted = [{
            dataField: 'CreatedDate',
            order: 'desc'
        }];
        const columns = [
            {
                dataField: 'OrderNumber',
                text: 'Order Number',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '150px', textAlign: 'center' };
                },
                formatExtraData: this.state,
                formatter: (cell, row, props, p) => {
                    return <Link to={{
                        pathname: 'view_order_details',
                        state: {
                            user: p.user,
                            input: row
                        }
                    }}> {cell} </Link>
                },
            },
            {
                dataField: 'CreatedDate',
                text: 'Date Created',
                sort: true,
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '150px', textAlign: 'center' };
                }
            },
            {
                dataField: 'OrderType',
                text: 'Order Type',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '135px', textAlign: 'center' };
                }
            },
            {
                dataField: 'DisplayID',
                text: 'Boland Reference ID',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '190px', textAlign: 'center' };
                }
            },
            {
                dataField: 'PurchaseOrder',
                text: 'PO Number',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '150px', textAlign: 'center' };
                }
            },
            {
                dataField: 'BuildingName',
                text: 'Building',
                sort: true
            },
            {
                dataField: 'OrderDescription',
                text: 'Order Description'
            },
            {
                dataField: 'Status',
                text: 'Status',
                sort: false,
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center' };
                }
            }

        ];
        const { data, sizePerPage, page, totalSize } = this.state;
        const customStyle = {
            padding: '10px',
            margin: '10px',
            maxWidth: '480px'
        };
        const { accounts, selectedAccounts } = this.state;
        const customValueRenderer = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "Filter by account";
        };
        return (
            <div class='building_view'>
                <SiteMenu user={this.state.user} currentPage='orderHistory' />
                <Form onSubmit={this.handleSearch}  className="mb-3">

                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px', justifyContent: 'right' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label class='padding_left_zero_xs' style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B' }}>ORDER HISTORY</Form.Label>
                        </Col>
                        <Col md="auto">
                            <Button as={Link} to={{
                                pathname: "/open_orders",
                                state: {
                                    user: this.state.user
                                }
                            }} size="sm" style={{ backgroundColor: '#00973A' }}>
                                Track Open Orders
                            </Button>
                        </Col>
                        <Col width="100%">
                        </Col>
                        <Col md="auto">
                            <MultiSelect
                                style={{ width:'300px' }}
                                className="multiselect sm"
                                options={accounts}
                                onChange={this.selectAccounts}
                                labelledBy="Select"
                                value={selectedAccounts}
                                valueRenderer={customValueRenderer}
                                hasSelectAll={false}
                            />
                        </Col>
                        <Col md="auto">
                            <Form.Select ref={this.filterStatus} value={this.state.filterStatus} onChange={this.handleFilterChange} placeholder="Filter by status" size="sm" name="filterStatus" style={{ width: "200px" }}>
                                <option key='blankChoice' hidden value="">Filter by status</option>
                                <option value="Open">Open</option>
                                <option value="Closed">Closed</option>
                            </Form.Select>
                        </Col>
                        <Col md="auto">
                            <Form.Select ref={this.filterType} value={this.state.filterType} onChange={this.handleFilterChange} defaultValue="Filter by order type" size="sm" name="filterType" style={{width:"200px"}}>
                                <option key='blankChoice' hidden value="">Filter by order type</option>
                                <option value="Parts">Parts</option>
                                <option value="Service">Service</option>
                                <option value="Contract">Contract</option>
                            </Form.Select>
                        </Col>
                        <Col md="auto" >
                            <Form.Control style={{ width: '320px' }} ref={this.filterText} type="input" size="sm" value={this.state.searchTerm}  onChange={this.handleSearchChange} placeholder="Search by order number, building, description..." />
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" className="button_first" style={{ paddingLeft: 0 }}>
                            <Button style={{ backgroundColor: '#1F419B' }} type="submit" size="sm">
                                Search
                            </Button>
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                            <Button size="sm" onClick={this.handleClear} variant="secondary" >
                                Clear
                            </Button>
                        </Col>
                    </Form.Group>
                </Form>
                <BootstrapTable
                    bootstrap4
                    remote
                    keyField="Id"
                    wrapperClasses="order_history table-responsive"
                    data={data}
                    columns={columns}
                    defaultSorted={defaultSorted}
                    //filter={filterFactory()}
                    pagination={paginationFactory({ page, sizePerPage, totalSize })}
                    striped
                    hover
                    noDataIndication={this.loadingSpinner}
                    loading={this.state.loading}
                    style={customStyle}
                    totalSize={this.state.totalSize}
                    onTableChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default ViewOrders;